import { PrefetchApiConfigItemType } from "@al/next/dist/lib/al-ex/prefetchApi";
// import { CountryID } from "@al/base-lib";
import { ReduxHelperItemObj, ReduxHelperItemFunc } from "@al/base-lib/dist/ReduxHelper/types";

type AsyncFuncInputType = ReduxHelperItemFunc<Record<string, unknown>>;

const request = (url: string, methods = "post"): AsyncFuncInputType => ({ async }): ReduxHelperItemObj =>
  async((params, ctx) =>
    ctx.io[methods as "get" | "post"](
      url,
      // { countryId: ctx.locale.countryId, ...params },
      { ...params },
      { headers: { "Content-Type": "application/json", "device-id": ctx.deviceId } }
    )
  );

const prefetchConfig = (url: string, data = {}, method: "GET" | "POST" = "POST"): PrefetchApiConfigItemType => ({
  url,
  method,
  type: "JSON",
  data: {
    // countryId: `${CountryID[]}?$query.countryId:$cookie.countryId?$cookie.countryId:7`,
    ...data,
  },
});

export { request, prefetchConfig };

export default {
  // 获取用户地址列表
  getUserAddressList: "/capi/personal/user/address/v1/list",
  // 获取用户默认有效地址
  getUserDefaultValidAddress: "/capi/personal/user/address/v1/country/default-address-query",
  // 获取商品基本信息
  getProductDetailBase: "/capi/itemdetail/public/item/detail/base",
  // 商详-sku价格
  getProductSkuInfos: "/capi/itemdetail/public/item/detail/sku-price",
  // 商详—图文详情
  getProductDesc: "/capi/itemdetail/public/item/detail/desc",
  // 商详—评价列表
  getDetailEvaluate: "/capi/itemdetail/public/item/detail/comment-list",
  // 商详—优惠券列表
  getProductCoupons: "/capi/itemdetail/public/item/detail/coupon-list-v2",
  // 商详—平台保障信息
  getPlatformGuarantee: "/capi/itemdetail/public/item/detail/platform-guarantee-info",
  // 商详—手动领取优惠券
  getCoupon: "/capi/itemdetail/user/coupon/receive",
  // 商详—批量领券优惠券(自动领券)
  getCouponAuto: "/capi/itemdetail/user/coupon/batch-receive",
  // 商详—运费
  getFreight: "/capi/itemdetail/public/item/detail/freight",
  // 商详—订单信息统计，销量
  getSpuSales: "/capi/itemdetail/public/item/detail/order-statistics",
  // 商详-分享ActionKey接口
  getShareParams: "/capi/background/public/deeplink/action/jump/link/addOrSearch",
  // -------------- 搜推 ------------------
  // 商详—重构商品相似推荐
  getSimilarProduct: "/capi/recommend/public/api/json/item/recommend/similar/get",
  // 重构商品相关推荐
  getRelateProduct: "/capi/recommend/public/api/json/item/recommend/relate/get",
  // 店铺内商品推荐接口
  getShopRelatedProduct: "/capi/recommend/public/api/json/item/recommend/shopRelated/get",
  // 获取省份列表
  getProvinces: "/capi/personal/public/common/address/provinces",
  // 获取分期
  getInstallmentPlants: "/capi/itemdetail/public/item/detail/installment-plans-v2",
  getDeeplink: "/capi/background/public/deeplink/action/jump/link/addOrSearch",
  getShopInfo: "/capi/itemdetail/public/item/detail/shop-info",
};
